import Component from './form-input';
export default Component;
